import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { homeQueryKeys } from '../../../constants/queryKeys/home';
import { HomeTab, HomeTabList, HomeTabListOption, HomeTabListRequestDto } from '../../../types/home/tab';
import { homeApiV2 } from '../../../lib/api/home/homeApiV2';
import { HomeTabsFindAllResponseBodyDto, HomeTabsFindAllResponseBodyHomeTabDto } from '../../../types/api/home-tabs';
import { UseQueryOptions } from '@tanstack/react-query/src/types';

export const homeTabListRequestOptionConverter = {
  clientToServer: (option: HomeTabListOption): HomeTabListRequestDto => ({
    page: option.page,
    pageSize: option.pageSize,
    status: option.status,
  }),
};

export const homeTabConverter = {
  serverToClient: (tab: HomeTabsFindAllResponseBodyHomeTabDto): HomeTab => ({
    id: tab.id,
    link: { id: tab.linkId, name: tab.linkTitle },
    linkType: tab.linkType,
    linkUrl: tab?.linkUrl || null,
    no: tab.no,
    title: tab.title,
    memo: tab.memo,
    status: tab.status,
    period: {
      startDate: tab.startDate,
      endDate: tab.endDate,
    },
    createDate: tab.createDate,
    updateDate: tab.updateDate,
  }),
  clientToServer: (tab: HomeTab): HomeTabsFindAllResponseBodyHomeTabDto => ({
    id: tab.id,
    linkTitle: tab.link.name,
    linkType: tab.linkType,
    linkId: tab.link.id,
    linkUrl: tab?.linkUrl || null,
    no: tab.no,
    title: tab.title,
    memo: tab.memo,
    status: tab.status,
    startDate: tab.period.startDate,
    endDate: tab.period.endDate,
    createDate: tab.createDate,
    updateDate: tab.updateDate,
  }),
};

export const useHomeTabListQuery = (
  homeTabListOption: HomeTabListOption,
  options: UseQueryOptions<HomeTabsFindAllResponseBodyDto, AxiosError, HomeTabList>,
): UseQueryResult<HomeTabList, AxiosError> => {
  return useQuery(
    homeQueryKeys.tabList(homeTabListOption),
    () => homeApiV2.getHomeTabList(homeTabListRequestOptionConverter.clientToServer(homeTabListOption)),
    {
      select: (res) => ({ totalCount: res.totalCount, homeTabList: res.homeTabs.map(homeTabConverter.serverToClient) }),
      ...options,
    },
  );
};
